// List of sonicbox nameseos that require the user to complete a task first.
export const TASK_GATES = [];

// List of sonicbox nameseos that skip the intro screen and go directly to the first task.
export const SKIP_INTRO_TASKS = [];

const storageKey = (nameseo) => `taskCompleted_${nameseo}`;
const scopedStorageKey = (nameseo, user) => {
  const userid = user?.userid ?? user?.id ?? "anonymous";
  return `sonicbox-task-completion-v1:${userid}:${nameseo}`;
};

export const requiresTask = (nameseo, user = null) =>
  TASK_GATES.includes(nameseo) && !isTaskCompleted(nameseo, user);

export const isTaskCompleted = (nameseo, user = null) => {
  if (!nameseo || typeof window === "undefined") return false;

  return (
    window.localStorage.getItem(storageKey(nameseo)) === "1" ||
    window.localStorage.getItem(scopedStorageKey(nameseo, user)) === "1"
  );
};

export const markTaskCompleted = (nameseo, user = null) => {
  if (!nameseo || typeof window === "undefined") return;

  window.localStorage.setItem(storageKey(nameseo), "1");
  window.localStorage.setItem(scopedStorageKey(nameseo, user), "1");
};
